<template>
  <div class="main-header">
    <div class="hero-canvas">
      <div class="hero-image" />
      <div class="calendar-control">
        <div class="container">
          <div class="center-container">
            {{ $filters.translate('T_EVENT_CALENDAR') }}
            <div class="icon-buttons">
              <div class="month-selector">
                <div @click="onClickPrevious">
                  <div class="arrow arrow-left" />
                </div>
                <div class="label">
                  {{ getMonthYearText() }}
                </div>
                <div @click="onClickNext">
                  <div class="arrow arrow-right" />
                </div>
              </div>
              <div class="icon icon-list-grid" :class="selected.view" @click="onClickView" />
              <div v-if="!selected.isSearch" class="icon icon-day-week" :class="selected.duration" @click="onClickDuration">
                <span class="week-text">{{ $filters.translate('T_WEEK') }}</span>
                <span class="day-text">{{ $filters.translate('T_DAY') }}</span>
              </div>
            </div>
          </div>
          <div class="background-bu">
            <div class="icon background-b" />
            <div class="icon background-u" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import TranslateService from '@/services/TranslateService'

export default {
  props: [
    'selected'
  ],
  data () {
    return {
    }
  },
  methods: {
    onClickView () {
      let view = _.get(this.selected, 'view')
      if (view === 'list') {
        view = 'grid'
      } else {
        view = 'list'
      }
      _.set(this.selected, 'view', view)
      this.$emit('update:selected', this.selected)
      this.$emit('changeView', _.clone(this.selected))
    },
    onClickDuration () {
      let duration = _.get(this.selected, 'duration')
      if (duration === 'day') {
        duration = 'week'
      } else {
        duration = 'day'
      }
      _.set(this.selected, 'duration', duration)
      this.$emit('update:selected', this.selected)
      this.$emit('changeDuration', _.clone(this.selected))
    },
    getMonthYearText () {
      const month = _.toUpper(moment(this.selected.date).format('MMM'))
      return [
        this.$filters.translate(`T_${month}`),
        moment(this.selected.date).format('YYYY')
      ].join(' ')
    },
    onClickPrevious () {
      const newDate = moment(this.selected.date).add(-1, 'M').format('YYYY-MM-DD')
      _.set(this.selected, 'date', newDate)
      this.$emit('update:selected', _.clone(this.selected))
      this.$emit('change', _.clone(this.selected))
    },
    onClickNext () {
      const newDate = moment(this.selected.date).add(1, 'M').format('YYYY-MM-DD')
      _.set(this.selected, 'date', newDate)
      this.$emit('update:selected', _.clone(this.selected))
      this.$emit('change', _.clone(this.selected))
    }
  }
}
</script>

<style lang="scss" scoped>
@import './MainHeader.scss';
</style>
